var ECashbackStatus = /*#__PURE__*/ function(ECashbackStatus) {
    ECashbackStatus["NotAssigned"] = "notAssigned";
    ECashbackStatus["Assigned"] = "assigned";
    ECashbackStatus["Claimed"] = "claimed";
    ECashbackStatus["PayedOut"] = "payedOut";
    ECashbackStatus["PayOutFailed"] = "payOutFailed";
    return ECashbackStatus;
}(ECashbackStatus || {});
export { ECashbackStatus };
